// extracted by mini-css-extract-plugin
export default {"header":"Header_header__-SpPF","titleContainer":"Header_titleContainer__4JChB","title":"Header_title__if9EA","badge":"Header_badge__eoguG","description":"Header_description__xQSl5"};